// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__KkPZm","name":"ConsentHeader_name__3P6Nn","birthday":"ConsentHeader_birthday__1xDhl","skeleton":"ConsentHeader_skeleton__1Oods"};